import moment from "moment";

const DATE_FORMAT = ['MM/DD/YYYY', 'YYYY-MM-DD HH:mm:ss','M/D/YYY']

const PayrollImportReducer = (state, action) => {
    var { type, payload, callback } = action;

    // Personal Phone
    // Title

    let data = [];
    let calculate = [];
    let sorted;
    switch (type) {
        case 'SET_FETCH_PAYROLL_DATA':
            let payrollDataArr = payload.data;

            const defaultPermissionLevel = state.options.permissionLevel.find(r => r.name === "ROLE_DELIVERY_ASSOCIATE")?.id;
            const defaultSkill = state.options.skills.find(s => s.name === "Driver")?.id;

        
            payrollDataArr = payrollDataArr.map((d) => {
                // let managerId = d["supervisorOID"]
                // managerId = managerId ? managerId + d["payrollId"] : 'COMPANY_OWNER'

                return {
                    "select": false,
                    "import": false,
                    "payrollId": d["payrollId"],
                    "payrollMain": d["payrollMain"],
                    "payrollDriversId": d["payrollDriversId"],
                    "payrollDriverId": d["payrollDriverId"],
                    "name": d["firstName"] + " " + d["lastName"],
                    "transporterId": d["TransporterID"],
                    "dateOfBirth": d["birthDate"] ? new Date(d["birthDate"]).toLocaleDateString('en-US') : '',
                    "phone": d["personalPhone"],
                    "email": d["email"],
                    "secondaryEmail": d["secondaryEmail"],
                    "stationId": payload.selectedStation,
                    "payrollManagerId": d["supervisorOID"],
                    "managerId": d["supervisorOID"]+d["payrollId"],
                    "hireDate": d["hireDate"] ? new Date(d["hireDate"]).toLocaleDateString('en-US') : '',
                    "employmentStatusId": state.options.employmentStatus.find(s => s.name === d['status'])?.id ?? 2,
                    "permissionLevelId": defaultPermissionLevel,
                    "shirtSize": null,
                    "pantSize": null,
                    "shoeSize": null,
                    "licenseNumber": null,
                    "licenseState": null,
                    "licenseExpDate": d["ID expiration"],
                    "gasPin": null,
                    "dotMedicalExpDate": null,
                    "skillId": defaultSkill,
                    "personalPhone": d["Personal Phone Number"],
                    "driverAliases": [],
                    extra: {
                        "associateOID": d["associateOID"],
                        "supervisorOID": d["supervisorOID"],
                    }
                }
            });           

            const sortedByDefault = { field: 'hireDate', direction: 0 };
            sorted = sortBy(payrollDataArr, [sortedByDefault]);

            return {
                ...state,
                adpData: payload,
                rawData: payrollDataArr,
                data: payrollDataArr,
                columns: payload.columns,
                validation: calculateValidation(payrollDataArr, payload.columns),
                loading: false,
                sorted: sorted[0],
                sortedBy: sortedByDefault
            };

        case 'SET_SORT_BY':
            if (!payload.fields.length)
                return {
                    ...state,
                    sorted: undefined,
                    sortedBy: undefined
                };

            const { columnKey, direction } = payload.fields[0];
            const sortedBy = { field: columnKey, direction: direction === 'ASC' ? 1 : 0 };
            sorted = sortBy(state.data, [sortedBy]);

            return {
                ...state,
                sorted: sorted[0],
                sortedBy: sortedBy
            };

        case 'SEARCH':
            sorted = state.sortedBy ? sortBy(state.data, [state.sortedBy]) : [state.data];

            if (!payload) {
                return { ...state, sorted: sorted[0] };
            }

            const filtered = filterEmployees(sorted[0], payload);

            return { ...state, sorted: filtered };

        case 'SET_BULK_FIELD_DATA_UPDATE':
            data = state.data.map((d, k) => {
                d[payload.field] = payload.newValue;
                return d;
            });

            return {
                ...state,
                data: data,
                validation: calculateValidation(data, state.columns),
            };

        case 'SET_BULK_SELECTED_FIELD_DATA_UPDATE':
            data = state.data.map((d, k) => {
                if (!d.select)
                    return d;

                Object.entries(payload.fields)
                    .forEach(([key, value]) => {
                        if (value !== undefined) {
                            d[key] = value
                        }
                    })

                return d;
            });

            return {
                ...state,
                data: data,
                validation: calculateValidation(data, state.columns)
            };

        case 'SET_CSV_DATA':
            const emails = payload.data.filter(row => row.Status === 'ACTIVE').map(row => row.Email);

            state.data.forEach((d) => {
                if (!emails.includes(d.email))
                    return;

                const record = payload.data.find(row => row.Email === d.email);
                d.transporterId = record.TransporterID;
                d.driverAliases.push(record['Name and ID']);
            });

            return {
                ...state,
                validation: calculateValidation(state.data, state.columns),
                hasAssociatesData: true,
            };

        case 'SET_BULK_EDIT':
            return { ...state, bulkEdit: payload }

        case 'SET_OPTIONS':
            return { ...state, options: payload }

        case 'SET_VALIDATION':
            return {
                ...state,
                validation: calculateValidation(state.data, state.columns),
            };

        case 'SET_IMPORTING':
            const total = payload.length;
            const done = payload.filter(row => row.importingStatus !== undefined).length;

            return {
                ...state,
                importing: payload,
                importingStatus: {
                    total,
                    done,
                    progress: Math.ceil(done / total * 100)
                }
            }

        case 'STOP_IMPORTING':
            return {
                ...state,
                importing: undefined,
                importingStatus: undefined,
            }

        default:
            return state;
    }
};

const calculateValidation = (data, columns) => {
    const required = {};
    const recommended = {};
    let importingCount = 0;

    columns.forEach(column => {
        let c = {
            key: column.key,
            count: 0,
        };

        if (column?._required)
            required[column.key] = c;
        else if (column?._recommended)
            recommended[column.key] = c;
    })

    data.forEach(row => {
        if (!row.import)
            return;

        importingCount++;

        columns.forEach(({ key }) => {
            if (!row[key]) {
                if (required[key])
                    required[key].count++;
                else if (recommended[key])
                    recommended[key].count++;
            }
        })
    });

    return {
        importingCount,
        required,
        recommended,
        canImport: importingCount && Object.values(required).reduce((sum, c) => sum + c.count, 0) === 0,
        numberEmployeesWithRequired: Object.values(required).reduce((sum, c) => sum + c.count, 0)
    };
}

const filterEmployees = (dataArr, searchText) => {
    searchText = searchText.trim().toLowerCase();

    if (!searchText.length) {
        return dataArr;
    }

    return dataArr.filter((employee) => {
        return employee?.transporterId?.toLowerCase().includes(searchText)
            || employee?.name?.toLowerCase().includes(searchText)
            || employee?.email?.toLowerCase().includes(searchText)
            || employee?.secondaryEmail?.toLowerCase().includes(searchText)
            || employee?.phone?.toLowerCase().includes(searchText)
            ;
    });
};

const sortBy = (employees, criterias) => {
    return criterias.reverse().map(c => {
        let d = c.direction;
        return Array.from(employees).sort((f, s) => {
            let str1 = f[c.field];
            let str2 = s[c.field];

            if (moment(str1, DATE_FORMAT, true).isValid()) {
                const date1 = moment(str1, DATE_FORMAT);
                const date2 = moment(str2, DATE_FORMAT);
                return d === 0 ? date2 - date1 : date1 - date2;
            }

            if (typeof f[c.field] === "object") {
                str1 = str1.sort().join("~");
            }
            if (typeof f[c.field] === "number") str1 = f[c.field].toString();
            if (typeof f[c.field] === "boolean") str1 = f[c.field] ? "1" : "0";

            if (typeof s[c.field] === "object") {
                str2 = str2.sort().join("~");
            }
            if (typeof s[c.field] === "number") str2 = s[c.field].toString();
            if (typeof s[c.field] === "boolean") str2 = s[c.field] ? "1" : "0";

            switch (c.field) {
                default:
                    return d === 0 ? str1.localeCompare(str2) : str2.localeCompare(str1);
            }
        });
    });
};


const sortByDate = (arr, key, asc = true) => {
    return arr.sort((a, b) => {
        const dateA = moment(a[key], DATE_FORMAT);
        const dateB = moment(b[key], DATE_FORMAT);
        return asc ? dateA - dateB : dateB - dateA;
    });
}

export default PayrollImportReducer;
